export const vueRoutes = [
  '/',

  '/account',
  '/account/security',
  '/account/sessions',

  '/login',
  '/forgot-password',
  '/reset-password/_token',
  '/invite/_token',

  '/profile',
  '/profile/about',

  '/profile/personal',
  '/profile/hobbies',
  '/profile/skills',

  '/profile/interviews',
  '/profile/interviews/surveys/personal_info',
  '/profile/interviews/surveys/professional_profile',
  '/profile/interviews/surveys/actual_analysis',
  '/profile/interviews/surveys/personal_competencies',
  '/profile/interviews/surveys/target_analysis',
  '/profile/experiences',
  '/profile/languages',
  '/profile/professional',
  '/profile/educations',
  '/profile/contacts',
  '/profile/request',
  '/profile/search',
  '/vacancies/view/_slug',

  '/vacancies',
  '/vacancies/saved',
  '/vacancies/saved/favorites',

  '/notifications',
  '/notifications/archive',
  '/notifications/calendar',
  '/notifications/chat',
  '/notifications/chat/_slug',

  '/help',
  '/help/faq',
  '/help/data-protection',
  '/help/about-rocken',
  '/help/contact-support',

  '/hidden/profile-rri/pdf/_slug',
  '/profile/preview/_slug',

  '/candidate/interview/_slug',
  '/i/_slug',
  '/candidate/interview/_slug/done',
  '/candidate/interview/_slug/congrats',

  '/embed/user-sync',

  '/access-callback'
]

export const nuxtRoutes = [

  // Pages below are not used now
  '/under-construction'
]
